import { useCallback } from "react";
import { sendGTMEvent } from "@next/third-parties/google";

/**
 * dataLayer filter_category sabitleri (filtre başlığı - İngilizce)
 * Kullanıcı hangi filtre grubuna tıkladıysa bu değerlerden biri basılır.
 */
export const FILTER_CATEGORY_MAP = {
  location: "district / region",
  rating: "Guest rating",
  star: "Hotel stars",
  chain: "Chain",
  theme: "Theme",
  amenity: "Facility",
};

/**
 * Landing sayfası sıralama id -> dataLayer sorting_type
 */
export const LANDING_SORTING_TYPE_MAP = {
  "0": "recommended",   // Önerilen
  "6": "starsDesc",    // En Çok Yıldızlı
  "4": "ratingDesc",    // En Yüksek Puan
};

/**
 * Hotel landing sayfasında filtre uygulandığında dataLayer'a
 * custom_event (filter_applied) push eden hook.
 *
 * @returns {{ sendFilterAppliedEvent: (filterCategory: string, filterSubcategory: string, sortingType: string) => void, sendSortingAppliedEvent: (sortId: string) => void, getSortingType: (sortId: string) => string }}
 */
export function useHotelLandingFilterDataLayer() {
  const getSortingType = useCallback((sortId) => {
    const id = String(sortId ?? "0");
    return LANDING_SORTING_TYPE_MAP[id] ?? "recommended";
  }, []);

  const sendFilterAppliedEvent = useCallback(
    (filterCategory, filterSubcategory, sortingType) => {
      const resolvedSortingType =
        typeof sortingType === "string"
          ? sortingType
          : getSortingType(sortingType);

      sendGTMEvent({
        event: "custom_event",
        event_category: "filtering",
        event_action: "filter_applied",
        filter_product_category: "hotel",
        filter_category: filterCategory,
        filter_subcategory: filterSubcategory,
        sorting_type: resolvedSortingType,
      });
    },
    [getSortingType]
  );

  const sendSortingAppliedEvent = useCallback(
    (sortId) => {
      const filterSubcategory = getSortingType(sortId);
      sendGTMEvent({
        event: "custom_event",
        event_category: "filtering",
        event_action: "sorting_applied",
        filter_product_category: "hotel",
        filter_category: "sorting",
        filter_subcategory: filterSubcategory,
      });
    },
    [getSortingType]
  );

  return {
    sendFilterAppliedEvent,
    sendSortingAppliedEvent,
    getSortingType,
  };
}
